import axios from 'axios';
import {
  GET_ANNOUNCEMENT_DATA_REQUEST,
  GET_ANNOUNCEMENT_DATA_SUCCESS,
  GET_ANNOUNCEMENT_DATA_FAILURE,

  GET_ANNOUNCEMENT_DETAIL_REQUEST,
  GET_ANNOUNCEMENT_DETAIL_SUCCESS,
  GET_ANNOUNCEMENT_DETAIL_FAILURE,

  SET_SEEN_ANNOUNCEMENT_REQUEST,
  SET_SEEN_ANNOUNCEMENT_SUCCESS,
  SET_SEEN_ANNOUNCEMENT_FAILURE,

  GET_READ_ANNOUNCEMENT_COUNT_REQUEST,
  GET_READ_ANNOUNCEMENT_COUNT_SUCCESS,
  GET_READ_ANNOUNCEMENT_COUNT_FAILURE,

  SET_READ_ALL_ANNOUNCEMENT_REQUEST,
  SET_READ_ALL_ANNOUNCEMENT_SUCCESS,
  SET_READ_ALL_ANNOUNCEMENT_FAILURE
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';
import errorMessage from './errorMessage';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getAnnouncements = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_ANNOUNCEMENT_DATA_REQUEST
    });

    let res;

    if (getState().auth.isAuthenticated) {
      res = await axios.get(`${API_GATEWAY}/announcements?channel=WEB`);
    } else {
      res = await axios.get(`${API_GATEWAY}/announcements/anonymous?channel=WEB`);
    }

    dispatch({
      type: GET_ANNOUNCEMENT_DATA_SUCCESS,
      payload: res.data
    });
  } catch (e) {
    dispatch({
      type: GET_ANNOUNCEMENT_DATA_FAILURE,
      payload: (e.response && e.response.data) || errorMessage
    });
  }
};

export const getAnnouncementById = id => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_ANNOUNCEMENT_DETAIL_REQUEST
    });

    let res;

    if (getState().auth.isAuthenticated) {
      res = await axios.get(`${API_GATEWAY}/announcements/${id}`);
    } else {
      res = await axios.get(`${API_GATEWAY}/announcements/anonymous/${id}`);
    }

    dispatch({
      type: GET_ANNOUNCEMENT_DETAIL_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_ANNOUNCEMENT_DETAIL_FAILURE,
      payload: (e.response && e.response.data) || errorMessage
    });
  }
};

export const setSeenAnnouncement = () => async (dispatch, getState) => {
  if (getState().auth.isAuthenticated) {
    try {
      dispatch({
        type: SET_SEEN_ANNOUNCEMENT_REQUEST
      });

      let res = await axios.put(`${API_GATEWAY}/announcements/mark-all-as-seen?channel=WEB`);
  
      dispatch({
        type: SET_SEEN_ANNOUNCEMENT_SUCCESS,
        payload: res.data.unseenNewsCount
      });
    } catch (e) {
      dispatch({
        type: SET_SEEN_ANNOUNCEMENT_FAILURE,
        payload: (e.response && e.response.data) || errorMessage
      });
    }
  }
};

export const getReadAnnouncementCount = () => async (dispatch, getState) => {
  if (getState().auth.isAuthenticated) {
    try {
      dispatch({
        type: GET_READ_ANNOUNCEMENT_COUNT_REQUEST
      });

      let res = await axios.get(`${API_GATEWAY}/announcements/unread-announcements-count`);

      dispatch({
        type: GET_READ_ANNOUNCEMENT_COUNT_SUCCESS,
        payload: res.data.unReadNewsCount
      });
    } catch (e) {
      dispatch({
        type: GET_READ_ANNOUNCEMENT_COUNT_FAILURE,
        payload: (e.response && e.response.data) || errorMessage
      });
    }
  }
};

export const setReadAllAnnouncements = () => async dispatch => {
  try {
    dispatch({
      type: SET_READ_ALL_ANNOUNCEMENT_REQUEST
    });

    let res = await axios.put(`${API_GATEWAY}/announcements/mark-all-as-read?channel=WEB`);
  
    dispatch({
      type: SET_READ_ALL_ANNOUNCEMENT_SUCCESS,
      payload: res.data.unreadNewsCount
    });

    setTimeout(() => dispatch(getAnnouncements()), 2000);
  } catch (e) {
    dispatch({
      type: SET_READ_ALL_ANNOUNCEMENT_FAILURE,
      payload: (e.response && e.response.data) || errorMessage
    });
  }
};
